// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2327": "bb4c22d14ded","261": "4752969116ed","5336": "5083bc5218c4",}[chunkId] + ".css"
}